import { createElement, forwardRef } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import invariant from 'invariant';

import useAnalytics from 'Hooks/useAnalytics';

export default function withAnalytics(Component) {
  const displayName = `withAnalytics(${ (Component.displayName || Component.name || 'Component') })`;

  const WithAnalytics = forwardRef((props, ref) => {
    const analyticsContext = useAnalytics();
    invariant(analyticsContext, `You should not use <${displayName} /> outside a <AnalyticsProvider>`);
    return createElement(Component, {
      analytics: analyticsContext,
      ref,
      ...props
    });
  });

  WithAnalytics.displayName = displayName;
  WithAnalytics.WrappedComponent = Component;

  return hoistNonReactStatics(WithAnalytics, Component);
}
